import { EntitySource } from 'src/constants';

/**
 * A saved menu set's Menu Source, and the range or label ids that go with it. A set has source labels or ranges,
 * never both; with neither it takes any menu.
 */
export const getMenuSetSource = (rangeIds: string[], sourceMenuLabelIds: string[]): [EntitySource, string[]] => {
  if (sourceMenuLabelIds.length > 0) return [EntitySource.MENU_LABELS, sourceMenuLabelIds];
  if (rangeIds.length > 0) return [EntitySource.RANGES, rangeIds];
  return [EntitySource.LIBRARY, []];
};
